import { Component, inject, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { GoogleLoginProvider, GoogleSigninButtonModule, SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-auth-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, GoogleSigninButtonModule],
  templateUrl: './auth-page.component.html',
  styleUrl: './auth-page.component.scss'
})
export class AuthPageComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  errorMessage: string = '';
  loading: boolean = false;
  submitted: boolean = false;

  private authService = inject(AuthService);
  private socialAuthService = inject(SocialAuthService);
  private router = inject(Router);
  private fb = inject(FormBuilder);

  constructor() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.socialAuthService.authState.subscribe((user) => {
      if (user) {
        this.getAccessToken();
      }
    });
  }

  getAccessToken(): void {
    this.socialAuthService.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then(accessToken => {
      this.authService.loginGoogleApi(accessToken).subscribe({
        next: (res: any) => {
          this.router.navigate(['/']);
        },
        error: (error) => {
          this.errorMessage = 'Erreur lors de la connexion Google';
          console.error('Erreur Google:', error);
        }
      });
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.errorMessage = '';

    if (this.loginForm.valid) {
      this.loading = true;
      this.authService.login(this.loginForm.value).subscribe({
        next: (response: any) => {
          this.loading = false;
          this.router.navigate(['/']);
        },
        error: (error) => {
          this.loading = false;
          this.errorMessage = 'Identifiants incorrects';
          console.error('Erreur de connexion:', error);
        }
      });
    }
  }

  loginWithGoogle(): void {
    // La logique est gérée par ngAfterViewInit
  }

  clearErrors(): void {
    this.errorMessage = '';
  }

  // Getters pour accéder aux contrôles du formulaire
  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }
}